import dayjs from "dayjs";
const isRouteIntervalWithinWorkShift = (startTime, endTime, workShifts) => {
    return workShifts.some((shift) => {
        const shiftStart = dayjs(shift.plannedStartTime);
        const shiftEnd = dayjs(shift.plannedEndTime);
        return (startTime.isSameOrAfter(shiftStart) && endTime.isSameOrBefore(shiftEnd));
    });
};
const createRouteIntervalValidator = (workShifts, isStart, time) => {
    return (_, value) => {
        if (!value || workShifts.length === 0 || !time) {
            return Promise.resolve();
        }
        const startTime = isStart ? value : time;
        const endTime = isStart ? time : value;
        const isValidInterval = isRouteIntervalWithinWorkShift(startTime, endTime, workShifts);
        if (!isValidInterval) {
            return Promise.reject(new Error("Интервал маршрута должен полностью находиться в пределах одной рабочей смены"));
        }
        return Promise.resolve();
    };
};
export const createPlannedStartTimeValidator = (workShifts, expectedArrivalTime) => {
    return createRouteIntervalValidator(workShifts, true, expectedArrivalTime);
};
export const createExpectedArrivalTimeValidator = (workShifts, plannedStartTime) => {
    return createRouteIntervalValidator(workShifts, false, plannedStartTime);
};
export const createTechnicianValidator = (workShifts) => {
    return (_, value) => {
        if (!value)
            return Promise.resolve();
        if (workShifts.length === 0) {
            return Promise.reject(new Error("У техника нет ни одной рабочей смены"));
        }
        return Promise.resolve();
    };
};
